import _ from 'lodash';
import styled from 'styled-components';
import { SectionHead } from 'src/components/cards';
import { useMediaQuery } from 'react-responsive';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';

const CardV = dynamic(import('src/components/cards/card-v'));
const Carousels = dynamic(import('src/components/carousels'));

const SectionPopular = ({ sectionId = 'section-4', data }) => {
  // console.log(data);
  if (_.isEmpty(data)) return null;
  const router = useRouter();

  const isTabletOrMobile = useMediaQuery({ maxWidth: 690 });
  const isDesktop = useMediaQuery({ minWidth: 691 });
  return (
    <>
      {!_.isEmpty(data) && (
        <SectionWrapper className='bg-section --theme' id='section-4'>
          <div className='container position-relative'>
            <SectionHead data={'most view'} link={'/tags/popular-news'} />
            {/* --------------------------------- BLOCK POPULAR -------------------------------- */}
            <div className='row card-list'>
              {isDesktop && (
                <Carousels slideShow={4} mobileSlideShow={2} dots={false}>
                  {data?.map((item, index) => (
                    <div key={index} className='card-item col-12 col-md-6 col-lg-3'>
                      <CardV
                        data={item}
                        heading={item?.subCategory?.th ? item?.subCategory?.th : item?.category?.th}
                        pinTag={true}
                        //! DATALAYER
                        eventDataLayer={{
                          type: DATALAYER_TYPE.TRACK_INDEX,
                          router: router?.pathname,
                          section: sectionId,
                          data: {
                            title: item?.title,
                            heading: 'most view',
                            carousel: index + 1
                          }
                        }}
                      />
                    </div>
                  ))}
                </Carousels>
              )}
              {isTabletOrMobile && (
                <>
                  {data?.slice(0, 4)?.map((item, index) => (
                    <div key={index} className='card-item is-mobile col-6'>
                      <CardV
                        data={item}
                        heading={item?.subCategory?.th ? item?.subCategory?.th : item?.category?.th}
                        pinTag={true}
                        //! DATALAYER
                        eventDataLayer={{
                          type: DATALAYER_TYPE.TRACK_INDEX,
                          router: router?.pathname,
                          section: sectionId,
                          data: {
                            title: item?.title,
                            heading: 'most view',
                            index: index + 1
                          }
                        }}
                      />
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>
        </SectionWrapper>
      )}
    </>
  );
};

const SectionWrapper = styled.section`
  position: relative;
  display: block;
  .section-head {
    position: relative;
  }
  @media (max-width: 480px) {
    .byline {
      display: none;
    }
  }
  .card-list {
    margin: 0 -15px;
    @media (max-width: 690px) {
      margin: 0 -10px -24px -10px;
    }
    .custom-carousel {
      padding: 0;
    }
    .card-item {
      padding: 0 15px;
      @media (max-width: 690px) {
        padding: 0 10px;
      }
    }
    .is-mobile {
      .border-item {
        border-bottom: 1px solid rgba(120, 120, 120, 0.1);
        /* padding-bottom: 24px; */
        margin-bottom: 24px;
      }
    }
  }
  .card-v {
    @media (max-width: 690px) {
      .card-thumb .img-scale-animate .share-card {
        display: none;
      }
    }
    .meta-contents {
      .byline {
        span {
          color: #000;
        }
      }
      .meta {
        p,
        span,
        svg {
          color: #5e5e5e;
        }
      }
    }
  }

  .slick-slider {
    position: static;
    .slide-arrow,
    .slick-arrow {
      display: block !important;
      background-color: var(--primary-color);
      border: none;
      position: absolute;
      padding-left: 5px;
      top: 16px;
      right: 27px;
    }
    .next-arrow,
    .slick-next,
    .prev-arrow,
    .slick-prev {
      z-index: 1;
      font-size: unset;
      width: unset;
      height: unset;
      &:before {
        content: unset;
      }
      cursor: pointer;
      svg {
        vertical-align: middle;
        color: #000;
      }
    }
    .prev-arrow,
    .slick-prev {
      right: 48px;
      left: unset;
      z-index: 2;
      &:after {
        content: '/';
        padding-left: 5px;
        color: #a0a0a0;
        vertical-align: middle;
      }
    }
  }
  @media (max-width: 690px) {
    .slick-slider {
      position: relative;
      .slide-arrow,
      .slick-arrow {
        background-color: #000;
        position: relative;
        padding: 14px;
      }
      .next-arrow,
      .slick-next,
      .prev-arrow,
      .slick-prev {
        position: absolute;
        top: 30%;
        transform: translate(0, -30%);
        svg {
          vertical-align: middle;
          polyline {
            stroke: var(--primary-color);
          }
        }
      }
      .next-arrow,
      .slick-next {
        right: -2px;
      }
      .prev-arrow,
      .slick-prev {
        right: unset;
        left: -2px;
        z-index: 1;
        &:after {
          content: '';
        }
      }
    }
  }
  .img-scale-animate {
    .tag-pin {
      color: #000;
      box-shadow: inset 130px 0 0 0 #fff;
    }
    &:hover {
      .tag-pin {
        color: var(--primary-color);
        box-shadow: inset 130px 0 0 0 #000;
      }
    }
  }
`;

export default SectionPopular;
